var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCircleBrokenRight = function SvgArrowCircleBrokenRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#56ae91b7-6bf8-4bdf-985a-e0e3c0b88058a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#60646C",
    fillRule: "evenodd",
    d: "M8 2a6 6 0 0 0-5.197 3 .667.667 0 0 1-1.154-.667 7.333 7.333 0 1 1 0 7.334A.667.667 0 1 1 2.803 11 6 6 0 1 0 8 2m-.47 2.862c.26-.26.682-.26.943 0l2.666 2.667a.667.667 0 0 1 0 .942l-2.666 2.667a.667.667 0 0 1-.943-.943l1.529-1.528H1.334a.667.667 0 0 1 0-1.334h7.724l-1.53-1.528a.667.667 0 0 1 0-.943",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "56ae91b7-6bf8-4bdf-985a-e0e3c0b88058a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgArrowCircleBrokenRight;